/* ============================================================================
   landing-nav.js - landing top menu: active pill on click + scroll
   ============================================================================ */

export function initLandingNavActive() {
  const links = [...document.querySelectorAll(".landing-nav__links .nav__item[href^='#']")];
  if (!links.length) return;

  const sections = links
    .map((link) => ({
      link,
      id: link.getAttribute("href").slice(1),
      el: document.querySelector(link.getAttribute("href")),
    }))
    .filter((entry) => entry.el)
    .sort((a, b) => a.el.offsetTop - b.el.offsetTop);

  if (!sections.length) return;

  const nav = document.querySelector(".landing-nav");
  const scrollGap = 12;
  const navHeight = () => nav?.offsetHeight || 104;
  const scrollOffset = () => navHeight() + scrollGap;

  const sectionTarget = (el) => el.querySelector(".landing-section__head") || el;

  const sectionScrollTop = (el) => {
    const target = sectionTarget(el);
    return target.getBoundingClientRect().top + window.scrollY;
  };

  const scrollToSection = (el, smooth = true) => {
    if (!el) return;
    const top = sectionScrollTop(el) - scrollOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: smooth ? "smooth" : "instant" });
  };

  const setActive = (activeId) => {
    links.forEach((link) => {
      const id = link.getAttribute("href").slice(1);
      link.classList.toggle("is-active", activeId != null && id === activeId);
    });
  };

  const syncFromScroll = () => {
    const y = window.scrollY + scrollOffset() + 1;
    let active = sections[0].id;
    for (const entry of sections) {
      if (sectionScrollTop(entry.el) <= y) active = entry.id;
    }
    setActive(active);
  };

  links.forEach((link) => {
    link.addEventListener("click", (e) => {
      const id = link.getAttribute("href").slice(1);
      const el = document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      setActive(id);
      scrollToSection(el);
      history.replaceState(null, "", `#${id}`);
    });
  });

  const brand = document.querySelector(".landing-nav__brand[href^='#']");
  if (brand) {
    brand.addEventListener("click", (e) => {
      const id = brand.getAttribute("href").slice(1);
      const el = document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      setActive(id);
      scrollToSection(el);
      history.replaceState(null, "", `#${id}`);
    });
  }

  window.addEventListener("scroll", syncFromScroll, { passive: true });
  window.addEventListener("resize", syncFromScroll, { passive: true });

  if (location.hash) {
    const match = sections.find((s) => `#${s.id}` === location.hash);
    if (match) {
      setActive(match.id);
      requestAnimationFrame(() => scrollToSection(match.el, false));
    } else {
      syncFromScroll();
    }
  } else {
    syncFromScroll();
  }
}
